module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.action !== 'create') ? _c('div', {
    staticClass: "w5-component-field-title"
  }, [_vm._v(_vm._s(_vm._f("ftc")('datacenter/datacenter')) + ":")]) : _vm._e(), _vm._v(" "), (_vm.items && _vm.items.length) ? _c('div', {
    staticClass: "w5-vds-plan-list-block country",
    style: (_vm.readonly ? 'opacity: 0.6' : null)
  }, _vm._l((_vm.items), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "w5-vds-plan-list-item",
      class: {
        'selected': item.id == _vm.curValue, 'disabled': item.active === false, 'readonly-item': this.readonly
      },
      on: {
        "mouseover": function($event) {
          return _vm.mouseOver(item)
        },
        "mouseleave": _vm.mouseLeave,
        "click": function($event) {
          return _vm.onItemClick(item.id, item.active)
        }
      }
    }, [_c('div', {
      staticClass: "left-part"
    }, [_c('span', {
      staticClass: "flag-icon",
      class: 'flag-icon-' + item['country']
    })]), _vm._v(" "), _c('div', {
      staticClass: "right-part"
    }, [_c('span', {
      staticClass: "name"
    }, [_vm._v(_vm._s(_vm._f("ftc")(item['name'])))])]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.showedTopHintId === item.id),
        expression: "showedTopHintId === item.id"
      }],
      staticClass: "w5-field-top-hint"
    }, [_c('span', {
      directives: [{
        name: "withSafeTags",
        rawName: "v-withSafeTags",
        value: (_vm.localeFtc('service/no_hardware')),
        expression: "localeFtc('service/no_hardware')"
      }]
    })])])
  }), 0) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b909bb32"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/country.vue
// module id = 399
// module chunks = 0